/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

function Buttons(props) {
    return (
        <Grid
            id="shadow-round"
            item
            sm={8}
            xs={12}
        >
            <Button
                aria-label="add"
                fullWidth
                id={props.id ? props.id : 'all-button'}
                onClick={props.action}
                type="submit"
            >
                {props.name}
            </Button>
        </Grid>
    );
}

export default (Buttons);
